import React from 'react';
import { Box, useTheme } from '@mui/material';
import Sidebar from './Sidebar';

const DRAWER_WIDTH = 260;

const AdminLayout = ({ children, themeMode, toggleTheme }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar themeMode={themeMode} toggleTheme={toggleTheme} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: theme.palette.background.default,
          minHeight: '100vh',
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
        }}
      >
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            maxWidth: 1600,
            mx: 'auto',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;
